import { c as _c } from "react/compiler-runtime";
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@xefi/x-react/button';
import { Modal } from '@xefi/x-react/modal';
import { Tooltip } from '@xefi/x-react/tooltip';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToasts } from '@/hooks/useToasts';
import type { SurveyHome } from '@/models/survey';
import { SURVEY_STATUS } from '@/utils/constants';
import { useDeleteSurveyMutation } from '../../_hooks/useDeleteSurveyMutation';
type DeleteSurveyProps = {
  survey: SurveyHome;
};
export const DeleteSurvey = t0 => {
  const $ = _c(13);
  const {
    survey
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    addSuccessToast,
    addErrorToast
  } = useToasts();
  const deleteSurveyMutation = useDeleteSurveyMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t1;
  if ($[0] !== addErrorToast || $[1] !== addSuccessToast || $[2] !== deleteSurveyMutation || $[3] !== survey.id || $[4] !== t) {
    t1 = () => {
      if (deleteSurveyMutation.isPending) {
        return;
      }
      deleteSurveyMutation.mutate({
        surveyId: survey.id
      }, {
        onSuccess: () => {
          addSuccessToast(t("survey.deleted.success", {
            ns: "notifications"
          }));
          setIsModalOpen(false);
        },
        onError: () => {
          addErrorToast(t("survey.deleted.error", {
            ns: "notifications"
          }));
        }
      });
    };
    $[0] = addErrorToast;
    $[1] = addSuccessToast;
    $[2] = deleteSurveyMutation;
    $[3] = survey.id;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleDelete = t1;
  let t2;
  if ($[6] !== deleteSurveyMutation.isPending || $[7] !== handleDelete || $[8] !== isModalOpen || $[9] !== survey.gates.authorizedToDelete || $[10] !== survey.status || $[11] !== t) {
    t2 = survey.gates.authorizedToDelete && ([SURVEY_STATUS.DRAFT, SURVEY_STATUS.CLOSED] as string[]).includes(survey.status.label) ? <Modal isOpen={isModalOpen} title={t("survey.delete.title").toUpperCase()} onOpenChange={newOpen => {
      if (!deleteSurveyMutation.isPending) {
        setIsModalOpen(newOpen);
      }
    }} trigger={<Tooltip content={t("delete", {
      ns: "common"
    })} isDisabled={isModalOpen} placement="top" size="sm" trigger={<button aria-label={t("delete", {
      ns: "common"
    })} onClick={() => {
      setIsModalOpen(true);
    }} className="flex size-8 cursor-pointer items-center justify-center rounded-md transition-colors"><FontAwesomeIcon size="lg" icon={faTrashCan} /></button>} />} footer={<div className="flex justify-end gap-2"><Button variant="bordered" radius="md" className="border-primary/50" isDisabled={deleteSurveyMutation.isPending} onClick={() => {
        setIsModalOpen(false);
      }}>{t("cancel", {
          ns: "common"
        })}</Button><Button radius="md" onClick={handleDelete} isLoading={deleteSurveyMutation.isPending}>{t("delete", {
          ns: "common"
        })}</Button></div>}><div className="flex flex-col items-center gap-4 text-center"><p className="text-sm">{t("survey.delete.text")}</p><p className="text-sm opacity-70">{t("survey.delete.confirm")}</p></div></Modal> : <button aria-label={t("delete", {
      ns: "common"
    })} className="flex size-8 cursor-not-allowed items-center justify-center rounded-md opacity-40" disabled={true} onClick={_temp}><FontAwesomeIcon size="lg" icon={faTrashCan} /></button>;
    $[6] = deleteSurveyMutation.isPending;
    $[7] = handleDelete;
    $[8] = isModalOpen;
    $[9] = survey.gates.authorizedToDelete;
    $[10] = survey.status;
    $[11] = t;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
function _temp(event) {
  return event.stopPropagation();
}